'use client'

// import HeroGallery from '@/components/sections/HeroGallery'
import Hero from '@/components/sections/Hero'
import ServiceArea from '@/components/sections/ServiceArea'
import dynamic from 'next/dynamic'
import { useLanguage } from '@/contexts/LanguageContext'
import { callToActionTranslations } from '@/translations/callToAction'
import NeighbourhoodFave from '@/components/sections/NeighbourhoodFave'

const Services = dynamic(() => import('@/components/sections/Services'))
const Portfolio = dynamic(() => import('@/components/sections/Portfolio'))
const CallToActionSection = dynamic(() => import('@/components/ui/CallToActionSection'))
const Transformations = dynamic(() => import('@/components/sections/Transformations'))
const HowItWorks = dynamic(() => import('@/components/sections/HowItWorks'))
const Testimonials = dynamic(() => import('@/components/sections/Testimonials'))
const About = dynamic(() => import('@/components/sections/About'))
const TrustBadges = dynamic(() => import('@/components/sections/TrustBadges'))
const FAQ = dynamic(() => import('@/components/sections/FAQ'))
const MaintenanceSchedule = dynamic(() => import('@/components/sections/MaintenanceSchedule'))
const Contact = dynamic(() => import('@/components/sections/Contact'))
const BackToTop = dynamic(() => import('@/components/ui/BackToTop'))

export default function Home() {
  const { language } = useLanguage()
  const t = callToActionTranslations[language]

  return (
    <main className="min-h-screen" id="main-content">
      {/* <Navbar /> (hidden for hero variant preview) */}
      {/*
        To switch hero variants, comment/uncomment below:
        <HeroVariantMix />   // Main hero (dark, premium)
        <HeroVariant3 />     // Bright, energetic (not currently rendered)
      */}
      <Hero />
      <NeighbourhoodFave />
      <ServiceArea />
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-b from-emerald-50/50 to-white" />
        <div className="relative">
          <Services />
          <Portfolio />
          <CallToActionSection
            title={t.transformGarden.title}
            description={t.transformGarden.description}
            linkHref="#contact"
            linkText={t.transformGarden.linkText}
          />
          <Transformations />
          <HowItWorks />
          <Testimonials />
          <CallToActionSection
            title={t.joinClients.title}
            description={t.joinClients.description}
            linkHref="#contact"
            linkText={t.joinClients.linkText}
          />
          <About />
          <TrustBadges />
          <FAQ />
          <MaintenanceSchedule />
          <Contact />
        </div>
      </div>
      <BackToTop />
    </main>
  )
}
